/**
 * Elevio kb-kit uses <a href="https://reactjs.org/docs/context.html" target="_blank">React Context</a> under the hood to provide data to its components.
 *
 * Here is some basic information relating to these contexts.
 *
 * @module
 */
import { createContext } from 'react';
/**
 * This just stores the current search result we are 'looking' at.
 */
const SearchResultContext = createContext(null);
SearchResultContext.displayName = 'SearchResultContext';
/**
 * The ArticleContext is set on the article page. It contains the full article details.
 *
 * - It also contains related articles and the parent category.
 */
const ArticleFullContext = createContext(null);
ArticleFullContext.displayName = 'ArticleFullContext';
/**
 * An ArticleFragment is set when we loop over a list of articles.
 * It contains a subset of the full
 *
 * > **💡 NOTE**: If you use a component / hook that looks up an [[IArticleFragment]] and it doesn't find one but it does find an [[ArticleContext]] then it will use that.
 */
const ArticleFragmentContext = createContext(null);
ArticleFragmentContext.displayName = 'ArticleFragmentContext';
/**
 * The Category context contains info about the a category. It is set in the category page.
 */
const CategoryContext = createContext(null);
CategoryContext.displayName = 'CategoryContext';
const CategoriesContext = createContext([]);
CategoriesContext.displayName = 'CategoriesContext';
const ArticlesContext = createContext([]);
ArticlesContext.displayName = 'ArticlesContext';
export { ArticleFragmentContext, ArticleFullContext, ArticlesContext, CategoryContext, CategoriesContext, SearchResultContext, };
//# sourceMappingURL=index.js.map